/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssistantMessage } from './AssistantMessage';
import {
    AssistantMessageFromJSON,
    AssistantMessageFromJSONTyped,
    AssistantMessageToJSON,
} from './AssistantMessage';

/**
 * 
 * @export
 * @interface AssistantConversation
 */
export interface AssistantConversation {
    /**
     * 
     * @type {string}
     * @memberof AssistantConversation
     */
    context?: string;
    /**
     * 
     * @type {Array<AssistantMessage>}
     * @memberof AssistantConversation
     */
    messages: Array<AssistantMessage>;
}

/**
 * Check if a given object implements the AssistantConversation interface.
 */
export function instanceOfAssistantConversation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "messages" in value;

    return isInstance;
}

export function AssistantConversationFromJSON(json: any): AssistantConversation {
    return AssistantConversationFromJSONTyped(json, false);
}

export function AssistantConversationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistantConversation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'context': !exists(json, 'context') ? undefined : json['context'],
        'messages': ((json['messages'] as Array<any>).map(AssistantMessageFromJSON)),
    };
}

export function AssistantConversationToJSON(value?: AssistantConversation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'context': value.context,
        'messages': ((value.messages as Array<any>).map(AssistantMessageToJSON)),
    };
}

